import Text from 'components/Text/Text';
import React, { SetStateAction } from 'react';
import { Radio, RadioChangeEvent } from 'antd';
import classNames from 'classnames';
import style from './AdditionalInfoSwitch.module.scss';

interface IAdditionalInfoSwitch {
	infoMode: 'main' | 'additional';
	setInfoMode: React.Dispatch<SetStateAction<'main' | 'additional'>>;
}

const AdditionalInfoSwitch: React.FC<IAdditionalInfoSwitch> = ({ infoMode, setInfoMode }) => {
	const switchInfoMode = (e: RadioChangeEvent) => {
		setInfoMode(e.target.value);
	};

	const switchButtonClasses = (value: 'main' | 'additional') => {
		return classNames(style.switchButton, { [style.active]: infoMode === value });
	};

	return (
		<Radio.Group
			className={style.infoSwitch}
			buttonStyle="solid"
			size="large"
			defaultValue={infoMode}
			onChange={switchInfoMode}>
			<Radio.Button className={switchButtonClasses('main')} value="main">
				<Text translationNameSpace="listing" translationKey="mainInfoButton" asFragment={true} />
			</Radio.Button>
			<Radio.Button className={switchButtonClasses('additional')} value="additional">
				<Text translationNameSpace="listing" translationKey="additionallyInfoButton" asFragment={true} />
			</Radio.Button>
		</Radio.Group>
	);
};

export default AdditionalInfoSwitch;
